import axios from 'axios';

//设置超时时间
axios.defaults.timeout = 12 * 10000; //by guo 2020-3-18-20:25修改 请求超时时间

// var baseURL = 'http://47.104.3.68:7009/'; //部署上线的地址/
// var baseURL = 'http://127.0.0.1:7009/'; //公司测试环境
// var baseURL = 'http://192.168.110.204:7009/'; //公司测试环境
// var baseURL = 'http://111.47.8.27:7009/'; //石桥环境
// http://mtqq.jhqshfly.com:9098/prod/#/login
// var baseURL = 'http://mtqq.jhqshfly.com:9098/api/'; //部署恒运详地址/ 记得修改aotongPlay.html 搜索江汉福利院
// var baseURL = 'http://mtqq.jhqshfly.com:7009/'; //部署恒运详地址/ 记得修改aotongPlay.html 搜索江汉福利院
// var baseURL = 'http://8.139.254.215:7009/'; //部署上线的地址/
// var baseURL = 'http://219.140.191.70:7009/'; //东西湖线上地址/
// var baseURL = 'http://111.47.8.27:7009/'; //石桥部署上线的地址1/
// var baseURL = 'http://10.23.210.6:7009/'; //石桥部署上线的地址2/

var baseURL = 'https://whwrlj.com/api/'; //万融部署上线的地址/ 需要修改magicBox bracelet sleepMattresslist
// var baseURL = 'https://www.jiniankangyang.com/'; //吉年上线的地址/
// var baseURL = 'https://xs.lehuo.site/'; //https //乐活正式的用这个
// var baseURL = 'https://xs.lehuo.site/'; //https //正式的用这个
// var baseURL = 'https://web.lehuo.site/'; //https //浠水正式的用这个
/*---------记得修改 -baseURL -webSocketServer------*/
//websocket 变量声明和导出
var WebsocketServerUrl = {
//   webSocketServer:"ws://47.104.3.68:7005/websocket",//国内生产环境
  // webSocketServer:'wss://xs.lehuo.site/websocket',
  // webSocketServer:'wss://web.lehuo.site/websocket', //浠水
  // webSocketServer:"ws://192.168.10.63:7005/websocket",//公司测试环境
  // webSocketServer:"ws://192.168.31.211:7005/websocket",//家里测试环境
  // webSocketServer:"ws://mtqq.jhqshfly.com:7005/websocket",//恒运详 江汉福利院
  // webSocketServer:"ws://111.47.8.27:7005/websocket",//石桥1
//   webSocketServer:"ws://10.23.210.6:7005/websocket",//石桥2
  webSocketServer:"wss://whwrlj.com/websocket",//万融
  // webSocketServer:"ws://8.139.254.215:7005/websocket",//吉年
  // webSocketServer:"ws://219.140.191.70:7005/websocket",//东西湖
};

import { Message } from 'element-ui';

// 解决axios发送预请求问题，默认是非简单请求需要变为简单请求
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

export { WebsocketServerUrl };
export { baseURL };

/**
 * 封装get方法
 * @param url
 * @param data
 * @param acceptLanguage //接收的语言 zh_CN中文   ja_JP日文  life集团需要使用国际化请求的就需要传参为ja_JP  否则就默认为中文
 * @returns {Promise}
 */
export function get(url, params = {}, acceptLanguage) {
    acceptLanguage = acceptLanguage == '' || acceptLanguage == null || acceptLanguage == undefined ? 'zh_CN' : acceptLanguage;
    return new Promise((resolve, reject) => {
        axios
            .get(baseURL + url, {
                params: params,
                headers: {
                    'Accept-Language': acceptLanguage,
                    Authorization: window.sessionStorage.getItem('Authorization')
                }
            })
            .then((response) => {
                if (response.data.code == 200) {
                    resolve(response.data.result);
                } else if (response.data.code == 100010) {
                    //by guo 2019-11-30-13:07添加
                    setTimeout(() => {
                        //Message.error({message:"请重新登录"});
                        this.$router.push({
                            path: '/login'
                        });
                        return;
                    }, 500);
                } else {
                    Message.error({
                        message: '请求异常'
                    });
                }
            })
            .catch((error) => {
                reject(error);
                Message.error({
                    message: error.response.data.message
                });
            });
    });
}

/**
 * 封装postLogin方法
 * @param url
 * @param data
 * @param acceptLanguage //接收的语言 zh_CN中文   ja_JP日文  life集团需要使用国际化请求的就需要传参为ja_JP  否则就默认为中文
 * @returns {Promise}
 */
export function postLogin(url, data = {}, acceptLanguage) {
    acceptLanguage = acceptLanguage == '' || acceptLanguage == null || acceptLanguage == undefined ? 'zh_CN' : acceptLanguage;
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: baseURL + url,
            headers: {
                'Accept-Language': acceptLanguage,
                'Content-type': 'application/x-www-form-urlencoded',
                Authorization: 'Basic Y21ueS1jbGllbnQtdWFjOmNtbnlDbGllbnRTZWNyZXQ='
            },
            params: data
        })
            .then((response) => {
                if (response.data.code == 200) {
                    resolve(response.data.result);
                } else if (response.data.code == 100010) {
                    setTimeout(() => {
                        //Message.error({message:"请重新登录"});
                        this.$router.push({
                            path: '/login'
                        });
                        return;
                    }, 500);
                } else {
                    reject(response.data);
                    // Message.error({ message: "请求异常" });
                }
            })
            .catch((err) => {
                reject(err);
                if (err.response.data.message) {
                    Message.error({
                        message: err.response.data.message
                    });
                } else {
                    Message.error({
                        message: '请重新登录'
                    });
                }
            });
    });
}
/**
 * 封装post请求 form表单请求
 * @param url
 * @param data
 * @param acceptLanguage //接收的语言 zh_CN中文   ja_JP日文  life集团需要使用国际化请求的就需要传参为ja_JP  否则就默认为中文
 * @returns {Promise}
 */

export function postForm(url, data = {}, acceptLanguage) {
    acceptLanguage = acceptLanguage == '' || acceptLanguage == null || acceptLanguage == undefined ? 'zh_CN' : acceptLanguage;
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: baseURL + url,
            headers: {
                'Accept-Language': acceptLanguage,
                'Content-type': 'application/x-www-form-urlencoded',
                Authorization: window.sessionStorage.getItem('Authorization')
            },
            params: data
        })
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.status || response.data.code == 200) {
                        resolve(response.data);
                    } else if (response.data.code == 100010) {
                        setTimeout(() => {
                            //Message.error({message:"请重新登录"});
                            this.$router.push({
                                path: '/login'
                            });
                            return;
                        }, 500);
                    } else {
                        resolve(response.data);
                    }
                } else {
                    // resolve(response.data);
                    reject('请求异常');
                    Message.error({
                        message: '请求异常'
                    });
                }
            })
            .catch((error) => {
                if (typeof error.response !== 'undefined') {
                    if (error.response.status == 401) {
                        sessionStorage.removeItem('user');
                    } else {
                        reject(error);
                        Message.error({
                            message: error.response.data.message
                        });
                    }
                } else {
                    reject(error);
                }
            });
    });
}

/**
 * post json 字符串
 * 传入的是对象,然后封装为json字符串
 * @param url
 * @param data
 * @param acceptLanguage //接收的语言 zh_CN中文   ja_JP日文  life集团需要使用国际化请求的就需要传参为ja_JP  否则就默认为中文
 * @returns {Promise<any>}
 */
export function postJson(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(baseURL + url, JSON.stringify(data), {
                headers: {
                    'Accept-Language': 'zh_CN',
                    'Content-Type': 'application/json',
                    Authorization: window.sessionStorage.getItem('Authorization')
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.code == 200 || response.data.status) {
                        // 有些是code有些是status标记
                        resolve(response.data);
                    } else if (response.data.code == 100010) {
                        setTimeout(() => {
                            //Message.error({message:"请重新登录"});
                            this.$router.push({
                                path: '/login'
                            });
                            return;
                        }, 500);
                    } else {
                        resolve(response.data);
                        //Message.error({message:response.data.message});
                    }
                } else {
                    // resolve(response.data);
                    reject('请求异常');
                    Message.error({
                        message: '请求异常'
                    });
                }
            })
            .catch((error) => {
                resolve('error');
                if (error.response && error.response.status == 401) {
                    sessionStorage.removeItem('user');
                } else if (error.data == undefined) {
                    reject(error);
                } else {
                    reject(error);
                    Message.error({
                        message: error.response.data.message
                    });
                }
            });
    });
}

//封装post请求,
//可以不用传递token ,不传则使用默认的token
//@param acceptLanguage //接收的语言 zh_CN中文   ja_JP日文  life集团需要使用国际化请求的就需要传参为ja_JP  否则就默认为中文
export function post(url, paramData, token, type, acceptLanguage) {
    if (token == null || token == '') {
        token = window.sessionStorage.getItem('Authorization');
    }
    acceptLanguage = acceptLanguage == '' || acceptLanguage == null || acceptLanguage == undefined ? 'zh_CN' : acceptLanguage;
    if (type != null && type == 'json') {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: baseURL + url,
                headers: {
                    'Accept-Language': acceptLanguage,
                    'Content-type': 'application/json',
                    Authorization: token
                },
                params: {},
                data: paramData //不要序列化
            })
                .then((response) => {
                    if (response.data.code == 200) {
                        resolve(response.data.result);
                    } else if (response.data.code == 100010) {
                        setTimeout(() => {
                            Message.error({
                                message: '请重新登录'
                            });
                            this.$router.push({
                                path: '/login'
                            });
                            return;
                        }, 500);
                    } else {
                        reject(response.data);
                        // Message.error({message:"请求异常"});
                    }
                })
                .catch((error) => {
                    if (error.response.status == '401') {
                        this.$store.commit('logout');
                        this.$router.push({
                            path: '/login'
                        });
                    } else {
                        if (error.response.data.message) {
                            Message.error({
                                message: error.response.data.message
                            });
                        } else {
                            Message.error({
                                message: '服务器异常'
                            });
                        }
                    }
                });
        });
    } else {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: baseURL + url,
                headers: {
                    'Accept-Language': acceptLanguage,
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: token
                },
                params: paramData
            })
                .then((response) => {
                    if (response.data.code == 200) {
                        resolve(response.data.result);
                    } else if (response.data.code == 100010) {
                        setTimeout(() => {
                            //Message.error({message:"请重新登录"});
                            this.$router.push({
                                path: '/login'
                            });
                            return;
                        }, 500);
                    } else {
                        reject(response.data);
                        // Message.error({message:"请求异常"});
                    }
                })
                .catch((error) => {
                    if (error.response.status == '401') {
                        this.$store.commit('logout');
                        this.$router.push({
                            path: '/login'
                        });
                    } else {
                        if (error.response.data.message) {
                            Message.error({
                                message: error.response.data.message
                            });
                        } else {
                            Message.error({
                                message: '服务器异常'
                            });
                        }
                    }
                });
        });
    }
}

/**
 * post json 字符串
 * 传入的是对象,然后封装为json字符串
 * @param url
 * @param data
 * @param acceptLanguage //接收的语言 zh_CN中文   ja_JP日文  life集团需要使用国际化请求的就需要传参为ja_JP  否则就默认为中文
 * @returns {Promise<any>}
 */
export function postHeadJson(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(baseURL + url, JSON.stringify(data), {
                headers: {
                    'Accept-Language': 'zh_CN',
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.code == 200 || response.data.status) {
                        // 有些是code有些是status标记
                        resolve(response.data);
                    } else {
                        resolve(response.data);
                        //Message.error({message:response.data.message});
                    }
                } else {
                    // resolve(response.data);
                    reject('请求异常');
                    Message.error({
                        message: '请求异常'
                    });
                }
            })
            .catch((error) => {
                resolve('error');
                if (error.response && error.response.status == 401) {
                    sessionStorage.removeItem('user');
                } else if (error.data == undefined) {
                    reject(error);
                } else {
                    reject(error);
                    Message.error({
                        message: error.response.data.message
                    });
                }
            });
    });
}

/**
 * 封装post请求 上传文件
 * @param url
 * @param data
 * @returns {Promise}
 */

export function postFormData(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(baseURL + url, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: window.sessionStorage.getItem('Authorization')
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.status || response.data.code == 200) {
                        resolve(response.data);
                    } else {
                        resolve(response.data);
                    }
                } else if (response.data.code == 100010) {
                    setTimeout(() => {
                        //Message.error({message:"请重新登录"});
                        this.$router.push({
                            path: '/login'
                        });
                        return;
                    }, 500);
                } else {
                    reject('请求异常');
                    Message.error({
                        message: '请求异常'
                    });
                }
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    sessionStorage.removeItem('user');
                } else {
                    reject(error);
                    Message.error({
                        message: error.response.data.message
                    });
                }
            });
    });
}
